import get from 'transmute/get';
export const getKBEnabled = data => get('knowledgeBaseEnabled', data);